module.exports = __webpack_public_path__ + "static/media/lithonia-psychiatrist-psych.624c05df.jpg";